import { Table } from "flowbite-react";
import React, { useState, useEffect } from "react";
import axios from "axios";

function Viewdetails({ orderid }) {

    const [Order, setOrder] = useState({ sizevarientwithquantity: "", buyer_name: "", colour_name: "", style_name: "", orderdate: "", total_piece: 0, cutorderno: "", pono: "", noofbales: "", delivery_date: "" });
    const [Marker, setMarker] = useState({});

    useEffect(() => {
        fetchorder();
        fetchmarker();
    }, []);

    const fetchorder = async () => {
        try {
            const response = await axios.get(`order/orders/${orderid}`);
            const OrderData = response.data;
            setOrder({
                orderdate: OrderData.order_date,
                total_piece: OrderData.total_piece,
                cutorderno: OrderData.cut_order_no,
                pono: OrderData.job_no,
                noofbales: OrderData.no_of_bales,
                buyer_name: OrderData.buyer_name,
                colour_name: OrderData.colour_name,
                style_name: OrderData.style_name,
                delivery_date: OrderData.delivery_date,
                sizevarientwithquantity: OrderData.size_variant_quantity,
            });

        } catch (error) {
            console.error("Error fetching order data:", error);
        }
    };

    const fetchmarker = async () => {
        try {
            const response = await axios.get("master/size_variants");
            const markerData = response.data;
            setMarker(markerData);
            console.log(Marker)
        } catch (error) {
            console.error("Error fetching Marker data:", error);
        }
    };

    const updatedMarker =
        Order.sizevarientwithquantity && Marker.length > 0
            ? Object.entries(Order.sizevarientwithquantity).map(([size_id, quantity]) => {
                const markerItem = Marker.find((marker) => marker.size_id === parseInt(size_id));
                return {
                    size: markerItem ? markerItem.size : "Unknown",
                    quantity: parseInt(quantity),
                };
            })
            : [];

    const totalQuantity = updatedMarker.reduce(
        (total, item) => total + item.quantity,
        0
    );


    return (
        <>
            <div className="border-dashed overflow-x-auto">
                <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
                    <div className="flex items-center space-x-2">
                        <h6 className="text-sm font-medium text-sidebar-color dark:text-white">Buyer Name:</h6>
                        <h6 className="text-sm text-sidebar-color dark:text-white">{Order.buyer_name}</h6>
                    </div>
                    {/* <div className="flex items-center space-x-2">
                        <h6 className="text-sm font-medium text-sidebar-color dark:text-white">Colour:</h6>
                        <h6 className="text-sm text-sidebar-color dark:text-white">{Order.colour_name}</h6>
                    </div> */}
                    <div className="flex items-center space-x-2">
                        <h6 className="text-sm font-medium text-sidebar-color dark:text-white">PO No:</h6>
                        <h6 className="text-sm text-sidebar-color dark:text-white">{Order.pono}</h6>
                    </div>
                    <div className="flex items-center space-x-2">
                        <h6 className="text-sm font-medium text-sidebar-color dark:text-white">Order No:</h6>
                        <h6 className="text-sm text-sidebar-color dark:text-white">{Order.cutorderno}</h6>
                    </div>
                    <div className="flex items-center space-x-2">
                        <h6 className="text-sm font-medium text-sidebar-color dark:text-white">Style:</h6>
                        <h6 className="text-sm text-sidebar-color dark:text-white">{Order.style_name}</h6>
                    </div>
                    <div className="flex items-center space-x-2">
                        <h6 className="text-sm font-medium text-sidebar-color dark:text-white">Total Piece:</h6>
                        <h6 className="text-sm text-sidebar-color dark:text-white">{Order.total_piece}</h6>
                    </div>
                    <div className="flex items-center space-x-2">
                        <h6 className="text-sm font-medium text-sidebar-color dark:text-white">Order Date:</h6>
                        <h6 className="text-sm text-sidebar-color dark:text-white">{new Date(Order.orderdate).toLocaleDateString('en-GB')}</h6>
                    </div>
                    <div className="flex items-center space-x-2">
                        <h6 className="text-sm font-medium text-sidebar-color dark:text-white">Delivery Date:</h6>
                        <h6 className="text-sm text-sidebar-color dark:text-white">{new Date(Order.delivery_date).toLocaleDateString('en-GB')}</h6>
                    </div>
                </div>

                <div className="overflow-x-auto mt-4">
                    <Table className="border text-center">
                        <Table.Head className="border ">
                            <Table.HeadCell className="border min-w-[40px] max-w-[40px]">Size</Table.HeadCell>
                            {updatedMarker.map((item, index) => (
                                <Table.HeadCell className="border">{item.size}</Table.HeadCell>
                            ))}
                            <Table.HeadCell>Total</Table.HeadCell>
                        </Table.Head>
                        <Table.Body className="divide-y">
                            <Table.Row className="bg-white dark:border-gray-700 dark:bg-gray-800">
                            <Table.Cell className=" px-2">
  <div className="text-gray-900 dark:text-white w-full">
    Quantity
  </div> 
</Table.Cell>

                                {updatedMarker.map((item, index) => (
                                    <Table.Cell className="border">{item.quantity}</Table.Cell>
                                ))}
                                <Table.Cell className="border">{totalQuantity}</Table.Cell>
                            </Table.Row>
                        </Table.Body>
                    </Table>
                </div>

             

            </div>

        </>
    );
};

export default Viewdetails;
